// extracted by mini-css-extract-plugin
export var quantityInput = "_h7-0";